/**
 * CITTAM brand tokens (web-side).
 *
 * Mirror of the canonical values used by the mobile app at
 * `src/theme/tokens.ts` and the page shell at `index.html`'s `:root`.
 *
 * When changing any literal here, update both companion files in the same
 * commit. There is no shared workspace package yet.
 */
export const tokens = {
  brand: {
    primary: '#14B8A6',
    primaryDark: '#0F766E',
    accent: '#0D9488',
  },
  bg: {
    primary: '#0F172A',
    secondary: '#1E293B',
    card: 'rgba(30, 41, 59, 0.8)',
  },
  text: {
    primary: '#F8FAFC',
    secondary: '#CBD5E1',
    muted: '#94A3B8',
  },
  semantic: {
    success: '#22C55E',
    error: '#EF4444',
    warning: '#F59E0B',
  },
  border: {
    default: 'rgba(148, 163, 184, 0.2)',
    focus: '#14B8A6',
  },
  radius: { sm: 4, md: 8, lg: 12, xl: 16 },
  spacing: { xs: 4, sm: 8, md: 12, lg: 16, xl: 24, '2xl': 32 },
} as const;
